var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancelSessionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.175 5.47497L6.975 18.675C6.524 19.126 5.776 19.126 5.325 18.675C4.874 18.224 4.874 17.476 5.325 17.025L18.525 3.82497C18.976 3.37398 19.724 3.37398 20.175 3.82498C20.626 4.27598 20.626 5.02398 20.175 5.47497Z",
    fill: "#E14949"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.175 18.6767C19.724 19.1277 18.976 19.1277 18.525 18.6767L5.325 5.47673C4.874 5.02573 4.874 4.27773 5.325 3.82673C5.776 3.37573 6.524 3.37573 6.975 3.82673L20.175 17.0267C20.626 17.4777 20.626 18.2257 20.175 18.6767Z",
    fill: "#E14949"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelSessionIcon);
export default __webpack_public_path__ + "static/media/cancel-session-icon.945c52c2d4eca8642e8b056f24bc1a51.svg";
export { ForwardRef as ReactComponent };